import { Theme, css } from "@emotion/react";
import * as React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

import { ArrowBack } from "@livechat/design-system-icons";
import { Button, Heading, Icon } from "@livechat/design-system-react-components";

import { IViewContainerProps, ViewContainer } from "components/grid";
import Block from "components/layout/Block";
import {
  IApplication,
  IWithApplicationsState,
  isInReviewApplication,
  isPrivateApplication,
} from "store/entities/applications";

import { getProperListUrlForApp } from "../helpers";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-named-as-default
import ActionsDropdown from "./ActionsDropdown";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const backButtonCss = (theme: Theme) => css`
  &,
  &:hover {
    color: ${theme.primaryColor};
  }
`;

interface IProps extends IViewContainerProps {
  application?: IApplication;
  title?: string;
}

const ApplicationSettingsContainer: React.FC<IProps> = ({ children, title = "Application", application, ...props }) => {
  const history = useHistory();
  // @ts-expect-error TS(2345)
  const isPrivateApp = useSelector((state: IWithApplicationsState) => isPrivateApplication(state, application?.id));
  // @ts-expect-error TS(2345)
  const isInReviewApp = useSelector((state: IWithApplicationsState) => isInReviewApplication(state, application?.id));

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const goBack = () => {
    const backUrl = getProperListUrlForApp(isPrivateApp, isInReviewApp);
    history.push(backUrl);
  };

  const backButton = (
    <Block marginH="20px">
      <Button onClick={goBack} icon={<Icon source={ArrowBack} />} kind="plain" css={backButtonCss}>
        <Heading>{application?.name || title}</Heading>
      </Button>
    </Block>
  );

  const rightNodes = application && (
    <Block marginH="20px">
      <ActionsDropdown shouldRedirect application={application} />
    </Block>
  );

  return (
    <ViewContainer {...props} rightNodes={rightNodes} stackShowBackButton backButton={backButton}>
      {children}
    </ViewContainer>
  );
};

export default ApplicationSettingsContainer;
